export const en = {
  noAccess: (userName: string) =>
    `${userName} can no longer access this project.`,
  noFoundUser:
    'User has either been removed from this project or this organization.',
  noFoundTask:
    'This task has either been removed, or you do not have access to it.'
};

export type Translations = typeof en;
